import React from "react";

import PropTypes from 'prop-types';

const CartItemDetails = ({ details }) => <div>{details}</div>;

export default CartItemDetails;

CartItemDetails.propTypes = {
  details: PropTypes.string
};
